module.exports = __webpack_public_path__ + "img/johnston-health-logo.2ddba764.jpg";